module.exports = __webpack_public_path__ + "static/img/mada-dark-nobg.9eb93b55.png";